import { TextField } from "@mui/material";
import { FormikValues } from "formik";

import { useFieldError } from "../../../forms/missing-fields/hooks/useFieldError";
import { useOptionalLabel } from "../../useOptionalLabel";
import { FormikAutocompleteTextFieldProps } from "./FormikAutocompleteTextField.types";

export function FormikAutocompleteTextField<T extends FormikValues>({
  params,
  textFieldProps,
  formik,
  fieldPath,
  label,
  helperText,
  required,
  optional,
  ariaLabelledBy,
}: FormikAutocompleteTextFieldProps<T>) {
  const error = useFieldError(formik, fieldPath, label);
  const helperMessage = error ?? helperText;
  const isError = !!error;
  const resolvedLabel = useOptionalLabel(label, optional);

  return (
    <TextField
      sx={{
        minWidth: "0em",
        "& .MuiInputBase-inputSizeSmall": { fontSize: "0.875rem" },
        "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input": {
          paddingY: "2px",
        },
      }}
      {...params}
      margin="none"
      variant="outlined"
      size="small"
      slotProps={{
        inputLabel: { sx: { fontSize: "0.875rem" }, required },
        ...(ariaLabelledBy && { htmlInput: { ...params.inputProps, "aria-labelledby": ariaLabelledBy } }),
      }}
      {...textFieldProps}
      error={isError}
      helperText={helperMessage ?? " "}
      label={resolvedLabel}
    />
  );
}
